import axios from './api'

export const getContactInfo = () => {
  return axios.get('/site/content/contact')
    .then(res => res.data.data)
}

export const sendForm = (name, email, subject, comments, accepted_terms) => {
  let data = new FormData()
  data.append("name", name)
  data.append("email", email)
  data.append("subject", subject);
  data.append("comments", comments)
  data.append("accepted_terms", Number(accepted_terms))

  return axios({
    url: '/saveContactDataForm',
    method: 'POST',
    data
  })

}